import React from 'react';
import { SvgSprite } from 'modules/svgSprite';
import createModal from 'modules/modal';
import DefaultLayout from 'modules/modal/layouts';
import HeadlineHeader from 'modules/modal/components/headlineHeader';
import { toHtmlContent } from 'modules/helpers/strings';
import { colors } from 'variables';
import type { SvgSpriteType } from 'autogen/spriteData';

const themes = {
    clubmatas: {
        backgroundColor: colors.clubmatasBackground
    }
};

function openMenu(menu: HTMLElement, button: HTMLElement) {
    const { modalTheme } = menu.dataset;
    const headlineBorder = menu.dataset.headerBorder === 'true';

    const headline = button.dataset.menuHeadline;
    const headlineSprite = button.dataset.menuHeadlineSprite;
    let sprite;

    if (headlineSprite) {
        const spriteType = headlineSprite as SvgSpriteType;
        sprite = <SvgSprite sprite={spriteType} />;
    }

    const modal = createModal({
        layout: {
            component: <DefaultLayout className="asidemenu-modal" customTheme={themes[modalTheme] || {}} />,
            header: <HeadlineHeader headline={headline || sprite} borderBottom={headlineBorder} />
        }
    });
    modal({ open: true, content: toHtmlContent(menu.outerHTML) });
}

export default function asideMenu(menu: HTMLElement): void {
    const button = menu.parentNode.querySelector<HTMLElement>('.js-asideMenuDropdown');

    if (button) {
        button.addEventListener('click', () => openMenu(menu, button));
    }
}
